import { render, staticRenderFns } from "./ExtractionDossierDpc.vue?vue&type=template&id=3d7a5223&scoped=true"
import script from "./ExtractionDossierDpc.vue?vue&type=script&lang=js"
export * from "./ExtractionDossierDpc.vue?vue&type=script&lang=js"
import style0 from "./ExtractionDossierDpc.vue?vue&type=style&index=0&id=3d7a5223&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d7a5223",
  null
  
)

export default component.exports